const FORMULA_PREFIX_PATTERN = /^[=+\-@\t\r\n]/;

export const neutralizeSpreadsheetFormula = (value: unknown) => {
    if (typeof value !== 'string') {
        return value;
    }

    return FORMULA_PREFIX_PATTERN.test(value) ? `'${value}` : value;
};

export const sanitizeSpreadsheetRow = (row: Record<string, unknown>) => (
    Object.fromEntries(
        Object.entries(row).map(([key, value]) => [key, neutralizeSpreadsheetFormula(value)])
    )
);
